module.exports = __webpack_public_path__ + "img/avatar4.238c4ea9.png";